export class AppConsts {
    static readonly DateTimeShortFormat = 'dd/MM/yyyy';
    static readonly DateTimeWithTimeFormat = 'dd/MM/yyyy HH:mm';
}

export class LocalStorageConsts {
  public static readonly CurrentUserKey = 'currentUser';
  public static readonly AccessTokenKey = 'access_token';
  public static readonly RefreshTokenKey = 'refresh_token';
  public static readonly HealthCheckKey = 'last_healthcheck';
  public static readonly HealthCheckInterval = 30 * 1000;
}